var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var _handleProductSelect;
import { ThemeEvents } from "@theme/events";
import { Component } from "@theme/component";
import { StandardEvents, ProductSelectEvent } from "@shopify/events";
class ProductPrice extends Component {
  constructor() {
    super(...arguments);
    this.selectionGeneration = 0;
    this.selectionDetached = false;
    this.selectionTarget = null;
    __privateAdd(this, _handleProductSelect, (event) => {
      var _a;
      if (!(event.target instanceof Element) || event.target.closest("product-card")) return;
      if (!event.promise || typeof event.promise.then !== "function" || this.selectionDetached) return;
      if (((_a = event.product) == null ? void 0 : _a.id) && this.dataset.productId && String(event.product.id) !== String(this.dataset.productId)) return;
      const generation = ++this.selectionGeneration;
      return event.promise.then(({ detail }) => {
        if (this.selectionDetached || generation !== this.selectionGeneration) return;
        var _a2, _b;
        if (!(detail == null ? void 0 : detail.html)) return;
        const { html, newProduct } = detail;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }
        const { priceContainer, volumePricingNote } = this.refs;
        const newProductPrice = html.querySelector('product-price[data-block-id="'.concat(this.dataset.blockId, '"]'));
        if (!newProductPrice) return;
        const newPrice = newProductPrice.querySelector('[ref="priceContainer"]');
        if (newPrice && priceContainer) {
          priceContainer.replaceWith(newPrice);
        }
        const newNote = newProductPrice.querySelector('[ref="volumePricingNote"]');
        if (!newNote) {
          volumePricingNote == null ? void 0 : volumePricingNote.remove();
        } else if (!volumePricingNote) {
          newPrice == null ? void 0 : newPrice.insertAdjacentElement(
            "afterend",
            /** @type {Element} */
            newNote.cloneNode(true)
          );
        } else {
          volumePricingNote.replaceWith(newNote);
        }
        const installmentsInput = (
          /** @type {HTMLInputElement|null} */
          this.querySelector("#product-form-installment-".concat(this.dataset.blockId, ' input[name="id"]'))
        );
        if (installmentsInput) {
          installmentsInput.value = (_b = (_a2 = detail.resource) == null ? void 0 : _a2.id) != null ? _b : "";
          installmentsInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }).catch((error) => {
        if ((error == null ? void 0 : error.name) !== "AbortError") console.warn("[product-price] Event promise rejected:", error);
      });
    });
  }
  connectedCallback() {
    var _a;
    super.connectedCallback();
    this.selectionDetached = false;
    const closestSection = this.closest(".shopify-section, dialog");
    if (!closestSection) return;
    (_a = this.selectionTarget) == null ? void 0 : _a.removeEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect));
    this.selectionTarget = closestSection;
    closestSection.addEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect));
  }
  disconnectedCallback() {
    var _a;
    super.disconnectedCallback();
    this.selectionDetached = true;
    ++this.selectionGeneration;
    (_a = this.selectionTarget) == null ? void 0 : _a.removeEventListener(StandardEvents.productSelect, __privateGet(this, _handleProductSelect));
    this.selectionTarget = null;
  }
}
_handleProductSelect = /* @__PURE__ */ new WeakMap();
if (!customElements.get("product-price")) {
  customElements.define("product-price", ProductPrice);
}
